export { Flex } from './Flex';

export type { FlexProps } from './Flex';
